import { DEFAULT_PARTNER_CODE, SLUG_LOGIN, SLUG_OTP } from "../constants";
import { getStorageItem } from "../helpers/utils";

export const isLeadSubmitButtonDisabled = (
  isFormSubmitted,
  form,
  errorMessage
) => {
  return (
    isFormSubmitted ||
    (form.step === SLUG_LOGIN &&
      (!form.mobile || errorMessage.mobile || !form.agree)) ||
    (form.step === SLUG_OTP &&
      (!form.otp || form.otp.length < 6 || errorMessage.otp))
  );
};

export const isCustomerDetailsProceedButtonDisabled = (
  isFormSubmitted,
  form,
  errorMessage,
  selectedCityOption,
  selectedStateOption,
  capturePan = false
) => {
  return (
    isFormSubmitted ||
    !form.name ||
    !form.mobile ||
    // !form.email ||
    !form.dob ||
    !form.gender ||
    !form.address ||
    errorMessage.mobile ||
    errorMessage.email ||
    errorMessage.name ||
    errorMessage.dob ||
    errorMessage.gender ||
    errorMessage.address ||
    !selectedCityOption?.code ||
    !selectedStateOption?.code ||
    ((capturePan || form.panRequired || form.pan_number) &&
      !form.verify_pan_number) ||
    (form.captureFatherName && !form.father_name)
  );
};

export const isDeclarationProceedButtonDisabled = (declation) => {
  let flag = true;
  for (var k in declation) {
    flag = flag && declation[k];
  }

  return !flag;
};

export const isAdditionalDetailsProceedButtonDisabled = (
  isFormSubmitted,
  form,
  errorMessage,
  selectedOccupationOption = null
) => {
  const code = selectedOccupationOption?.code;
  const label = selectedOccupationOption?.label;
  const risk_categorization = selectedOccupationOption?.risk_categorization;
  const disabled =
    isFormSubmitted ||
    !form.annual_income ||
    !form.education ||
    !form.father_name ||
    !form.organisation_name ||
    !code ||
    !label ||
    (form.income_tax_proof === "PAN" &&
      (!form.verify_pan_number ||
        !form.declaration ||
        !form.pan_number ||
        errorMessage.pan_number)) ||
    errorMessage.education ||
    errorMessage.father_name ||
    errorMessage.organisation_name ||
    errorMessage.annual_income ||
    risk_categorization === "High" ||
    (form.einsurance_account === "Yes" && !form.einsurance_account_number);

  return disabled;
};

export const isBankDetailsProceedButtonDisabled = (
  isFormSubmitted,
  form,
  errorMessage,
  selectedBankOption = null,
  selectedSalesPersonOption = null,
  selectedBranchNameOption = null,
  branchName = null,
  isTestDetails = false
) => {
  const label = selectedBankOption?.label ?? null;
  const code = selectedBankOption?.code ?? null;
  const salesPersonLabel = selectedSalesPersonOption?.label ?? null;
  const salesPersonCode = selectedSalesPersonOption?.code ?? null;
  const branchLabel = selectedBranchNameOption?.label ?? null;
  const branchCode = selectedBranchNameOption?.code ?? null;
  const isSalesPersonRequired =
    getStorageItem("partnerCode") == DEFAULT_PARTNER_CODE;

  return (
    isFormSubmitted ||
    !label ||
    !code ||
    (isSalesPersonRequired &&
      (!salesPersonLabel || !salesPersonCode || !branchLabel || !branchCode)) ||
    !form.bank_account_holder_name ||
    !form.bank_account_number ||
    !form.bank_account_type ||
    !form.bank_ifsc_code ||
    // (!branchName && !isTestDetails) ||
    errorMessage.bank_account_holder_name ||
    errorMessage.bank_account_number ||
    errorMessage.bank_name ||
    errorMessage.bank_account_type ||
    errorMessage.bank_ifsc_code
  );
};

export const isValidPAN = (pan) => {
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
  return panRegex.test(pan.toUpperCase());
};
